:host {
    // offset for link default inside
    --offset: 3px;

    align-items: flex-start;
    display: flex;
    flex-direction: column;
    gap: 12px;

    .headline {
        @include typo-ws-h4;

        margin: 0;
    }
}

::slotted(sew-ws-linklist) {
    padding-left: 22px;
}
